var firstInputVisible = false;
var secondInputVisible = false;
var thirdInputVisible = false;

window.togglePasswordVisibilityUsers = function togglePasswordVisibilityUsers(num){
    let element = document.getElementById('pass'+num).childNodes;
    let passElement = element[3];

    // old password toggle
    if(num === 0){
        let icon = document.getElementById('viewShowPassOld');
        if (icon === null || icon === undefined) {
            icon = document.getElementById('viewShowPassYour');
        }

        if(thirdInputVisible === false){
            passElement.type = 'text';
            thirdInputVisible = true;

            if (icon.classList.contains('fa-eye')) {
                icon.classList.remove('fa-eye');
                icon.classList.add('fa-eye-slash');
            }

        } else {
            passElement.type = 'password';
            thirdInputVisible = false;
                    
            if (icon.classList.contains('fa-eye-slash')) {
                icon.classList.remove('fa-eye-slash');
                icon.classList.add('fa-eye');
            }   
        }
    }

    if(num === 1){
        let icon = document.getElementById('viewShowPassFirst');

        if(firstInputVisible === false){
            passElement.type = 'text';
            firstInputVisible = true;
                    
            if (icon.classList.contains('fa-eye')) {
                icon.classList.remove('fa-eye');
                icon.classList.add('fa-eye-slash');
            }

        } else {
            passElement.type = 'password';
            firstInputVisible = false;
                    
            if (icon.classList.contains('fa-eye-slash')) {
                icon.classList.remove('fa-eye-slash');
                icon.classList.add('fa-eye');
            }   
        }

    } 

    if (num === 2) {
        let icon = document.getElementById('viewShowPassSecond');
        if (secondInputVisible === false){
            passElement.type = 'text';
            secondInputVisible = true;

            if (icon.classList.contains('fa-eye')) {
                icon.classList.remove('fa-eye');
                icon.classList.add('fa-eye-slash');
            }                     
        } else {
            passElement.type = 'password';
            secondInputVisible = false;

                if (icon.classList.contains('fa-eye-slash')) {
                    icon.classList.remove('fa-eye-slash');
                    icon.classList.add('fa-eye');
                }   
        }

    }
    
}

var toggleFirstInputVisible = false;
var toggleSecondInputVisible = false;

window.togglePasswordVisibility=function togglePasswordVisibility(input){
    let passElement = document.getElementById(input);

    if(input === 'password'){
        let icon = document.getElementById('viewShowPassFirst');

        if(toggleFirstInputVisible === false){
            passElement.type = 'text';
            toggleFirstInputVisible = true; 
                    
            if (icon.classList.contains('fa-eye')) {
                icon.classList.remove('fa-eye');
                icon.classList.add('fa-eye-slash');
            }

        } else {
            passElement.type = 'password';
            toggleFirstInputVisible = false;
                    
            if (icon.classList.contains('fa-eye-slash')) {
                icon.classList.remove('fa-eye-slash');
                icon.classList.add('fa-eye');
            }   
        }

    } else {
        let icon = document.getElementById('viewShowPassSecond');
            if (toggleSecondInputVisible === false){
                passElement.type = 'text';
                toggleSecondInputVisible = true;

                if (icon.classList.contains('fa-eye')) {
                    icon.classList.remove('fa-eye');
                    icon.classList.add('fa-eye-slash');
                }                     
            } else {
                passElement.type = 'password';
                toggleSecondInputVisible = false;

                if (icon.classList.contains('fa-eye-slash')) {
                    icon.classList.remove('fa-eye-slash');
                    icon.classList.add('fa-eye');
                }   
            }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/scripts/togglepwd.js